import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { Country } from '../models';

@Injectable({
  providedIn: 'root'
})
export class CountryService{
    constructor(
        private http: HttpClient,
        private apiService: ApiService
    ) { }

    public getAllCountries(countrySearchParam:IGlobalSearchParam):Observable<any> {
      console.log(countrySearchParam);
      return this.apiService.post(`Country/SearchCountry`,countrySearchParam)
    }

    public getCountryDetail(countryId:number):Observable<any> {
      // console.log(countryId);
      return this.apiService.getInd(`Country/${countryId}`)
    }

    public deleteCountryDetail(countryId:number):Observable<any> {
      return this.apiService.delete(`Country/${countryId}`)
    }

    public updateCountryDetail(countryId:number, country:Country):Observable<any> {
      return this.apiService.put(`Country/${countryId}`, country)
    } 
    
    public postCountryDetail(country:Country):Observable<any> {
      return this.apiService.post(`Country`, country)
    } 

    public ExportCountry(searchParam:IGlobalSearchParam):Observable<any> {
      return this.http.post(`${environment.apiRoot}Country/ExportCountry`, searchParam,
      {  
          responseType: 'blob',
          observe: 'response'
       });
    }

}
